import React, { SetStateAction, useContext, useEffect, useState } from "react";
import {
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { AuthContext } from "../../AuthContext/AuthContext";
import { get } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import { BarraDeFerramentas } from "../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { CustomSelect, CustomTextField } from "../../Styles/theme/customThemeprovider";
import { drapToChoose } from "../../informacao_estatica";
import LoadingVulpesSmall from "../../Styles/Loader/loadingSmall";
import { ColorPicker, useColor, type IColor } from "react-color-palette";
import "react-color-palette/css";
interface INovoCadernoManualProps {
  setValueYear_arg: (obj: Dayjs | null) => void;
  setDrapChoose_arg: (choose_drap: string) => void;
  set_obj_template_escolhido_arg: (obj: any) => void;
  handleCreateCaderno_arg: () => void;
  set_cor_aux: React.Dispatch<SetStateAction<string>>;
  set_cultura_aux: React.Dispatch<SetStateAction<string>>;
}

export const DialogNovoCadernoManual = ({
  setDrapChoose_arg,
  setValueYear_arg,
  set_cor_aux,
  set_cultura_aux,
  // set_obj_template_escolhido_arg,
  handleCreateCaderno_arg
}: INovoCadernoManualProps) => {
  const auth = useContext(AuthContext);

  const [isloading, setIsLoading] = useState(true);
  const [valueYear, setValueYear] = useState<Dayjs | null>(dayjs);
  // const [templateList_for_select, setTemplateList_for_select] = useState<any[]>();
  // const [obj_template_escolhido, set_obj_template_escolhido] = useState<any>();
  const [drapChoose, setDrapChoose] = useState<string>("Norte");
  const [cultura, set_cultura] = useState<string>("");
  const [cor, set_cor] = useColor("#C4C4C4");

  const onChangeComplete = (color: IColor) => set_cor_aux(color.hex);



  const getAllTemplates = async () => {
    try {
      const urlrelativa = `/get_template_org/${auth.user?.id_org}`;

      const res = await get(auth.token.cookie_token, urlrelativa);
      if (res.status === 200) {
        let lista_templates_for_select_aux = [
          { value: -1, label: "Caderno em Branco" },
        ];
        res.data.result.forEach((el: any) => {

          lista_templates_for_select_aux.push({
            value: el.id_template,
            label: el.decricao,
          });
        });
        // set_obj_template_escolhido(lista_templates_for_select_aux[0])

        // setTemplateList_for_select(lista_templates_for_select_aux);
        setIsLoading(false);
      } else {
        setIsLoading(false);

      }
    } catch (error) {
      func_print("getAllTemplates", error, true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await getAllTemplates();
    })();
  }, []);

  // OnChage DRAP
  const handleChangeDrap = (
    event: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>
  ) => {
    setDrapChoose_arg(event.target.value)
    setDrapChoose(event.target.value);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflowY: 'auto',
          width: '100%'

        }}
      >

        <div>
          {isloading ?
            <LoadingVulpesSmall />
            : <div style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 100
            }}>
              {/* <div
                style={{
                  // backgroundColor: cores.cor1,
                  display: "flex",
                  alignItems: 'center',
                  justifyContent: 'center',
                  // flex: 0.1,
                  fontWeight: 'bold',
                  // color: 'white',
                  fontSize: 25,
                  width: '100%',
                  fontFamily: "candara"
                }}>

                Criação de Caderno


              </div>*/}
              <div style={{
                minHeight: 50

              }}>
              </div> 

              <CustomSelect
                value={drapChoose}
                name="drap"
                onChange={handleChangeDrap}
                options={drapToChoose}
                label="Selecione Drap"
                minWidth={255}
              />
              <div style={{
                minHeight: 20

              }}>
              </div>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year"]}
                  label={
                    <Typography fontFamily="candara" fontSize={18}>
                      Selecionar ano
                    </Typography>
                  }
                  value={valueYear}
                  onChange={(valueYear) => {
                    setValueYear(valueYear);
                    setValueYear_arg(valueYear)
                  }}
                  maxDate={dayjs()}
                  minDate={dayjs("2010")}
                // renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>

              <div style={{
                paddingBottom: 5,
                paddingTop: 2

              }}>

                <CustomTextField
                  value={cultura}
                  name="cultura"
                  onChange={(event: any) => {
                    set_cultura(event.target.value)

                    set_cultura_aux(event.target.value)
                  }}
                  label="Cultura"
                  minWidth={200}
                />
              </div>
              <div >
                <ColorPicker
                  height={100}
                  hideAlpha={true}
                  hideInput={["rgb", "hsv"]}
                  color={cor} onChange={set_cor} onChangeComplete={onChangeComplete} />
              </div>



            </div>
          }
        </div>
      </div>
      <Stack width={'100%'} direction="row" display="flex" justifyContent="end" paddingTop={5} paddingRight={5} paddingBottom={5}>
        <BarraDeFerramentas
          mostrarBotaoNovo
          aoClicarNovo={() => handleCreateCaderno_arg()}
          textoBotaoNovo="CRIAR"
        />
      </Stack>
    </>
  );
};

